import { ReactNode } from "react";
import { Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";

interface Props {
    title: string | ReactNode;
    className?: string;
    children?: ReactNode;
}

const SimpleCard = (props: Props) => {
    const { t } = useTranslation("candidate_portal");


    return (
        <>
            <Card
                className={`dashboard-card ${props.className}`}
                style={{ gap:'2.5rem'} }
            >
                <>
                    <div className="w-100 dashboard-header-content">{props.title}</div>
                    {props.children}
                </>
            </Card>
        </>
    )
};
export default SimpleCard;